import React from 'react';
import { Outlet } from 'react-router-dom';
import ManagementSidebar from './ManagementSidebar';

const ManagementPage: React.FC = () => {
    return (
    <div className="dashboard-main">
      <ManagementSidebar />
      <div className="dashboard-content" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Outlet />
      </div>
    </div>
  );
};

export default ManagementPage; 